import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfigurationService, AuthCookieService } from 'kolektor-services';
import { UserInfo } from './shared/models/user-cookie-info';
import { HeaderConfigurationService } from './services/header-configuration.service';
import { takeUntil } from 'rxjs/operators';
import { FiscalizacionesEncriptadas } from './shared/models/fiscalizaciones-encriptadas';
import { NavBarOptions } from 'kolektor-ui-components/lib/interfaces/navbar-options.interface';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'MI RENTAS | Formulario de pago';
  footerOptions: Array<any>;

  constructor(
    private configurationService: ConfigurationService,
    private authCookieService: AuthCookieService,
    private headConfigService: HeaderConfigurationService
  ) { }
  // const footerLinksKey = 'footerLinks';
  // const footerConfiguration = environment.settings[footerLinksKey];
  // this.footerOptions = [
  //   { name: 'Contacto', link: footerConfiguration.url_contacto },
  //   { name: 'Informacion fiscal', link: footerConfiguration.url_info },
  //   { name: 'Vencimientos', link: footerConfiguration.url_vencimientos },
  //   { name: 'Denuncias', link: footerConfiguration.url_denuncias }
  // ];

  subdomainForFooter: string;
  appSubdomainForFooter: string;
  user = new UserInfo();
  navBarOptions = {
    linkLogoRentas: '',
    loginStatusOptions: {
      linkMiPerfil: '',
      linkCorredor: '',
      linkMartillero: '',
      linkProcurador: '',
      linkMisRepresentados: '',
      linkFiscalizaciones: '',
      linkLogOut: '',
      linkCidiLogin: '',
      linkCidiSignIn: '',
      linkAfipLogin: '',
      linkAfipSingIn: '',
      linkMiInicio: '',
      webPersonalizada: {
        linkGoToPerfil: '',
        linkEditPerfil: ''
      }
    }
  };
  webSubDomain = '';
  isLogged = false;
  private componentDestroyed$: Subject<boolean> = new Subject();
  // menu data
  headerNavBarOptions: NavBarOptions = {
    linkInicio: {
      url: '/mi-perfil/mis-datos',
      isActive: false,
      menuText: 'Perfil'
    },
    linkImpuestos: {
      url: '/emisiontributaria/perfil/impuestos',
      isActive: false
    },
    linkConsultaTramites: {
      url: '/nuevorentas/tramites/consultar',
      isActive: false,
      menuText: 'Consulta de Gestiones'
    },
    linkNuevoTramite: {
      url: '/gestiones',
      isActive: false,
      menuText: 'Nueva Gestión'
    },
    linkPagos: {
      url: '/pagos/consulta',
      isActive: false
    },
    linkDomicilioFiscal: {
      url: '/nuevorentas/domicilio-fiscal',
      isActive: false
    },
    linkDebito: {
      url: '/nuevorentas/mis-planes',
      isActive: false
    },
    linkPlanesDePago: {
      url: '/debito-automatico/consulta/planes-de-pago',
      isActive: false
    },
    linkDeclaracionesJuradas: {
      url: '/declaraciones/sellos',
      isActive: false
    },
    linkMiInicio: {
      isActive: false,
      url: '',
      menuText: 'Mi Inicio'
    },
    tramitesName: 'Gestiones'
  };
  isOmega = false;
  userData: any;
  environment: any;

  ngOnInit() {
    this.configEnvironments();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
  /**
   * @description Registra los datos del usuario logueado que necesita el header transversal
   * @param userInfoCookie user Info obtenido de la cookies
   */
  configUser(userInfoCookie: any) {
    // User info
    const nameCookie = userInfoCookie.nombre || '';
    this.user.name = nameCookie.replace(/[+]/g, ' ');
    this.user.cuit = userInfoCookie.cuit;
    this.isLogged = userInfoCookie.isLogged;
    this.user.hasRepresantos = userInfoCookie.representantes && userInfoCookie.representantes.length > 1;
    this.user.isCorredor = userInfoCookie.corredor === 1;
    this.user.isProcurador = userInfoCookie.procurador === 1;
    this.user.isMartillero = userInfoCookie.martillero === 1;
    this.user.hasFiscalizaciones = userInfoCookie.fiscalizaciones ? true : false;
    this.configHeaderLinks();
    this.environment = environment;
  }
  configEnvironments() {
    this.configurationService.getConfigByEnviroment('assets/environments/').subscribe((data: any) => {
      const settings = data.settings;
      this.navBarOptions = settings.headerData;
      // Setting cookie name in cookie service to use the service then
      this.authCookieService.loadUserFromCookie(settings.cookieName);
      // set cookie value to user
      const userInfoCookie = this.authCookieService.getUserInfo();
      this.userData = userInfoCookie;
      this.setNavbarOptions(userInfoCookie);
      this.configUser(userInfoCookie);
      this.subdomainForFooter = environment.settings.webSubDomain;
      this.appSubdomainForFooter = environment.settings.servicesSubdomain;
    });
  }

  configHeaderLinks = () => {
    if (this.user.hasFiscalizaciones) {
      this.headConfigService
        .configureFiscalizacionesLink(
          this.authCookieService.getUserInfo().fiscalizaciones,
          this.user.cuit
        )
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe((response: FiscalizacionesEncriptadas) => {
          const linkFiscalizaciones = environment.settings.navBarOptions.loginStatusOptions.linkFiscalizaciones;
          const fisca = response.fiscalizacion_encriptado;
          const urlfull = linkFiscalizaciones + encodeURIComponent(fisca);
          this.navBarOptions.loginStatusOptions.linkFiscalizaciones = urlfull;
        });

    }
  };

  private setNavbarOptions(user) {
    this.isOmega = user.esContribuyenteOmega === 'SI' || user.esContribuyenteOmega === 'true';
    if (this.isOmega) {
      this.headerNavBarOptions.linkMiInicio.url = '/mi-inicio/';
      this.navBarOptions.loginStatusOptions.webPersonalizada.linkEditPerfil = `${environment.settings.baseWebUrl}mi-perfil/mis-datos`;
    }
  }
}
